module.exports = __webpack_public_path__ + "img/page13.bc0526f8.png";